import { extractApiError } from '@/lib/apiError'
import Sunny16BaseService from '@/services/Sunny16BaseService'

import type {
  AccountSessionResponse,
  LoginRequest,
  PasswordResetCompleteRequest,
  PasswordResetInitiateRequest,
  PasswordResetVerifyRequest,
  PasswordResetVerifyResponse,
  RegisterRequest
} from '@VelocitySquared/cady-sunny16-commerce-integration-models'

class Sunny16CadyAccountService extends Sunny16BaseService {
  constructor() {
    super(import.meta.env.VITE_SUNNY_16_API_BASE_URL, 'Sunny16CadyAccountService', {
      reportClientErrors: false
    })
  }

  async registerUser(request: RegisterRequest): Promise<AccountSessionResponse> {
    try {
      const response = await this.axiosInstance.post('cady/accounts/register', request)
      return response.data
    } catch (error) {
      throw new Error(extractApiError(error, 'Registration failed.'))
    }
  }

  async loginUser(request: LoginRequest): Promise<AccountSessionResponse> {
    try {
      const response = await this.axiosInstance.post('cady/accounts/login', request)
      return response.data
    } catch (error) {
      throw new Error(extractApiError(error, 'Login failed.'))
    }
  }

  async requestPasswordReset(email: string): Promise<void> {
    try {
      const passwordResetRequest: PasswordResetInitiateRequest = {
        Email: email
      }
      const response = await this.axiosInstance.post(
        'cady/accounts/password-reset/initiate',
        passwordResetRequest
      )
      return response.data
    } catch (error) {
      throw new Error(extractApiError(error, 'Password reset request failed.'))
    }
  }

  async verifyPasswordResetCode(email: string, code: string): Promise<PasswordResetVerifyResponse> {
    try {
      const passwordResetVerifyRequest: PasswordResetVerifyRequest = {
        Email: email,
        Code: code
      }
      const response = await this.axiosInstance.post(
        'cady/accounts/password-reset/verify',
        passwordResetVerifyRequest
      )
      return response.data
    } catch (error) {
      throw new Error(extractApiError(error, 'Invalid or expired code. Please try again.'))
    }
  }

  async submitNewPassword(resetSession: string, newPassword: string): Promise<void> {
    try {
      const submitNewPasswordRequest: PasswordResetCompleteRequest = {
        ResetSession: resetSession,
        NewPassword: newPassword,
        NewPasswordConfirmation: newPassword
      }
      const response = await this.axiosInstance.post(
        'cady/accounts/password-reset/complete',
        submitNewPasswordRequest
      )
      return response.data
    } catch (error) {
      throw new Error(extractApiError(error, 'Password reset failed.'))
    }
  }
}

export default Sunny16CadyAccountService
